import * as yup from "yup";

yup.addMethod(yup.string, "nombreNodo", function (errorMessage) {
  return this.test(`nombre-nodo`, errorMessage, function (value) {
    const { path, createError } = this;
    const t = `${value}`.toLowerCase().substring(0, 10);
    return ( t !== "parametro" || createError({ path, message: errorMessage })
    );
  });
});

export const validations = {
  NodeBasic: () => yup.object({
    nombre: yup.string().required().nombreNodo("El nombre del nodo no puede comenzar con 'parametro'" ).max(50),
    descripcion: yup.string().nullable(),
  }),
  NodeUI: () => yup.object({
    nombre: yup.string().required().nombreNodo("El nombre del nodo no puede comenzar con 'parametro'" ).max(50),
    descripcion: yup.string().nullable(),
  }),  
  NodeProcess: () => yup.object({
    nombre: yup.string().required().nombreNodo("El nombre del nodo no puede comenzar con 'parametro'" ).max(50),
    descripcion: yup.string().nullable(),
    script: yup.string(),
  }),
  NodeIterator: () => yup.object({
    nombre: yup.string().required().nombreNodo("El nombre del nodo no puede comenzar con 'parametro'" ).max(50),
    descripcion: yup.string().nullable(),
    campoIteracion: yup.string().max(50).required("El campo de iteración es requerido"),
  }),
  NodeOperation: () => yup.object({
    nombre: yup.string()
    .required().nombreNodo("El nombre del nodo no puede comenzar con 'parametro'" ).max(50),
    descripcion: yup.string().nullable(),
    idOperacionDestino: yup.number().required("La operación de destino es requerida."),
  }),
  NodeStart: () => yup.object({
    nombre: yup.string().required().nombreNodo("El nombre del nodo no puede comenzar con 'parametro'" ).max(50),
    descripcion: yup.string().nullable(),
  }),
  NodeBase: () => yup.object({
    label: yup.string(),
    content: yup.string(),
    connectionType: yup.string()
    .required("El tipo de conexión es requerido"),
  }),
  NodeSticky: () => yup.object({
    nombre: yup.string().max(50),
    anotacion: yup.string().nullable(),
  }),
  LoadTxt: () => yup.object({
    code: yup.string().required("El código es requerido"),
  }),
  EdgeEdit: () => yup.object({
    nombre: yup.string(),
  }),
  SelectNodeType: () => yup.object({
    type: yup.string(),
  }),
  EditProps: () => yup.object({
    tipoOperacion: yup.string(),
    nombre: yup.string(),
    imagen: yup.string(),
    orden: yup.string(),
    activa: yup.string(),
  }),
  AddNode: () => yup.object({
    categoria: yup.string(),
    tipo: yup.string(),
    label: yup.string(),
    content: yup.string(),
    connectionType: yup.string(),
  }),
  default: () => yup.object({})
}
